import React, { Component } from 'react';


class Linelogin extends Component {

    render() { 
        const link = "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id="+
                        process.env.REACT_APP_LINE_CHANNEL_ID+
                        "&redirect_uri=https://aps-cooling.firebaseapp.com/loginverifyline&state=12345abcde&scope=openid%20profile&nonce=09876xyz"
        return ( <a href={link}><img src={require("../../static/images/01_login/login_line.png")} alt="linelogin"/></a> );
    }
}
 
export { Linelogin }